import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import Badge from '../Badge';
import type { BadgeProps } from '../../types';
import { VettedIcon } from './VettedIcon';
import { VettedBadgeTheme } from './types';

interface VettedProBadgeProps extends Omit<BadgeProps, 'disablePadding'>, VettedBadgeTheme {
  variant?: 'default' | 'short' | 'compact';
}

const LABEL = 'Vetted Pro';
const LABEL_SHORT = 'Pro';

const VettedProBadge = ({
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
  variant = 'default',
  theme = 'light',
}: VettedProBadgeProps) => {
  if (variant === 'compact') {
    return (
      <Badge dataTestId={dataTestId} backgroundColor="transparent" disablePadding>
        <VettedIcon theme={theme} />
      </Badge>
    );
  }

  const isDark = theme === 'dark';

  return (
    <Badge
      color={isDark ? 'white' : 'business_1100'}
      backgroundColor={isDark ? 'business_900' : 'business_400'}
      tooltipContent={translate('badges.vetted_pro.tooltip')}
      showTooltip={showTooltip}
      tooltipPosition={tooltipPosition}
      dataTestId={dataTestId}
      appendTooltipToBody={appendTooltipToBody}
      disableTooltipFlip={disableTooltipFlip}
    >
      <Typography width="max-content">{variant === 'short' ? LABEL_SHORT : LABEL}</Typography>
    </Badge>
  );
};

VettedProBadge.displayName = 'VettedProBadge';

export default VettedProBadge;
